import { warnAndNotify } from '@execonline-inc/error-reporting.private';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { AppyError, callApi } from '../../../../Appy';
import { handleError } from '../../../../ErrorActionableReaction';
import { MissingLinkError, findLinkT } from '../../../../LinkyLinky';
import { participantsOptionsResourceDecoder } from '../../../../ParticipantsStore/Options/Decoders';
import ReactionComponent, { RCProps } from '../../../../ReactionComponent';
import { Link } from '../../../../Resource/Types';
import GroupOptionsStore from './GroupOptionStore';
import { State } from './Types';

interface Props extends RCProps<GroupOptionsStore> {}

type OptionsError = AppyError | MissingLinkError;

const handleOptionsError = (store: GroupOptionsStore) => (error: OptionsError) => {
  switch (error.kind) {
    case 'missing-link-error':
      store.error('We are unable to process your request at this time');
      warnAndNotify('ParticipantsOptionsReactions', error.kind, error);
      break;
    default:
      handleError(store, error);
  }
};

const sendRequest = callApi(participantsOptionsResourceDecoder, {});

class GroupOptionsReactions extends ReactionComponent<GroupOptionsStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        Task.succeed<OptionsError, ReadonlyArray<Link>>(store.groupParticipantsStore.links)
          .andThen(findLinkT('options'))
          .andThen(sendRequest)
          .fork(handleOptionsError(store), store.ready);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default GroupOptionsReactions;
